import AboutContent from "../../components/aboutcontent/AboutContent.component";
import Heroimg2 from "../../components/heroimg2/HeroImg2.component";


const About = () =>{
    return(
        <div>
            <Heroimg2 heading="ABOUT ME." text="I'm a Front-End Developer"/>
            <AboutContent/>
        </div>
    )
}

export default About;